import { format, parseISO } from 'date-fns'
import type { JournalEntry } from '../lib/supabase'

interface Props {
  entry: JournalEntry
  onClick: (entry: JournalEntry) => void
}

function RatingDots({ value, max = 5 }: { value: number | null; max?: number }) {
  if (value === null) return <span style={{ color: 'var(--text-dim)', fontSize: '0.7rem' }}>—</span>
  return (
    <div className="rating-dots">
      {Array.from({ length: max }, (_, i) => (
        <div
          key={i}
          className={`rating-dot ${i < value ? 'filled' : ''} ${i < value && value <= 2 ? 'bad' : ''} ${i < value && value === 3 ? 'warn' : ''}`}
        />
      ))}
    </div>
  )
}

export function JournalEntryRow({ entry, onClick }: Props) {
  const outcomeClass = entry.outcome === 'win' ? 'win' : entry.outcome === 'loss' ? 'loss' : 'neutral'
  const tickerLabel = entry.ticker || (entry.entry_type === 'candidates' ? 'CANDS' : '—')

  return (
    <div className="journal-row" onClick={() => onClick(entry)}>
      <div className="journal-row-date">
        {format(parseISO(entry.trade_date), 'M/dd')}
      </div>
      <div className={`journal-row-ticker ${outcomeClass}`}>
        {tickerLabel}
      </div>
      <div className="journal-row-thesis">
        {entry.thesis || entry.entry_type.replace('_', ' ')}
      </div>
      <RatingDots value={entry.rule_adherence} />
      {entry.emotion_before && (
        <div className={`emotion-dot ${entry.emotion_before}`} title={entry.emotion_before} />
      )}
    </div>
  )
}
